import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';

@Component({
  selector: 'qb-sticky-app-header',
  templateUrl: './sticky-app-header.component.html',
  styleUrls: ['./sticky-app-header.component.scss'],
})
export class StickyAppHeaderComponent implements AfterViewInit, OnDestroy {
  constructor() {}

  @ViewChild('stickyHeader', { static: true })
  stickyHeader!: ElementRef<HTMLDivElement>;

  private resizeObserver?: ResizeObserver;

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(entries => {
      const borderBoxSize = entries[0]?.borderBoxSize?.[0];
      const ownHeight =
        borderBoxSize?.blockSize ?? entries[0]?.contentRect?.height ?? this.stickyHeader.nativeElement.offsetHeight;
      document.documentElement.style.setProperty('--sticky-header-height', `${ownHeight}px`);
    });
    this.resizeObserver.observe(this.stickyHeader.nativeElement, { box: 'border-box' });
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
